export const ACTION_TYPES = {
  // loadingSpinner
  START_LOADING: "START_LOADING",
  STOP_LOADING: "STOP_LOADING",
  CLEAR_LOADING: "CLEAR_LOADING",
  SET_LOADING_MSG: "SET_LOADING_MSG",

  // snackBar
  SHOW_SNACKBAR: "SHOW_SNACKBAR",
  HIDE_SNACKBAR: "HIDE_SNACKBAR",

  // API
  CALL_API: "CALL_API",

  // Account
  AUTHENTICATE_TEAMNOTE_JWT: "AUTHENTICATE_TEAMNOTE_JWT",
  SET_ME: "SET_ME",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  GET_ME: "GET_ME",

  // RBU Section List
  RBU_UPDATE_SECTION_TABLE_OPTIONS: "RBU_UPDATE_SECTION_TABLE_OPTIONS",
  RBU_RESET_SECTION_TABLE_OPTIONS: "RBU_RESET_SECTION_TABLE_OPTIONS",
  RBU_UPDATE_SECTION_FILTERS: "RBU_UPDATE_SECTION_FILTERS",
  RBU_RESET_SECTION_FILTERS: "RBU_RESET_SECTION_FILTERS",

  // RBU ITEM LIST
  RBU_UPDATE_SECTION_ITEM_TABLE_OPTIONS:
    "RBU_UPDATE_SECTION_ITEM_TABLE_OPTIONS",
  RBU_RESET_SECTION_ITEM_TABLE_OPTIONS: "RBU_RESET_SECTION_ITEM_TABLE_OPTIONS",

  RBU_UPDATE_SECTION_ITEM_FILTERS: "RBU_UPDATE_SECTION_ITEM_FILTERS",
  RBU_RESET_SECTION_ITEM_FILTERS: "RBU_RESET_SECTION_ITEM_FILTERS",

  // RBU ITEM MAPPING LIST
  RBU_UPDATE_SECTION_ITEM_MAPPING_OPTIONS:
    "RBU_UPDATE_SECTION_ITEM_MAPPING_OPTIONS",
  RBU_RESET_SECTION_ITEM_MAPPING_OPTIONS:
    "RBU_RESET_SECTION_ITEM_MAPPING_OPTIONS",
  RBU_UPDATE_SECTION_ITEM_MAPPING_FILTER:
    "RBU_UPDATE_SECTION_ITEM_MAPPING_FILTER",
  RBU_RESET_SECTION_ITEM_MAPPING_FILTER:
    "RBU_RESET_SECTION_ITEM_MAPPING_FILTER",

  // RBU ITEM LIST TAB
  RBU_UPDATE_ITEM_LIST_TAB: "RBU_UPDATE_ITEM_LIST_TAB",
  RBU_RESET_ITEM_LIST_TAB: "RBU_RESET_ITEM_LIST_TAB",

  // RBU EDITION LIST
  RBU_EDITION_UPDATE_ITEM_LIST_TABLE_OPTIONS:
    "RBU_EDITION_UPDATE_ITEM_LIST_TABLE_OPTIONS",
  RBU_EDITION_RESET_ITEM_LIST_TABLE_OPTIONS:
    "RBU_EDITION_RESET_ITEM_LIST_TABLE_OPTIONS",
  RBU_EDITION_UPDATE_ITEM_LIST_FILTER: "RBU_EDITION_UPDATE_ITEM_LIST_FILTER",
  RBU_EDITION_RESET_ITEM_LIST_FILTER: "RBU_EDITION_RESET_ITEM_LIST_FILTER",

  // RBU_ITEM_LIST_RESET_ALL
  RBU_ITEM_LIST_RESET_ALL: "RBU_ITEM_LIST_RESET_ALL",
};
